module.exports = __webpack_public_path__ + "img/harriet-tubman.259abca8.png";